import React from "react";
import ReactSelect, { Props } from "react-select";
import {
  COLOR_BLACK,
  COLOR_GRAY_300,
  COLOR_PRIMARY,
} from "../constants/colors";

const customStyles = {
  valueContainer: (provided: any, state: any) => ({
    ...provided,
    padding: ".25rem .75rem",
    fontSize: "1rem",
  }),
  control: (provided: any, state: any) => {
    return {
      ...provided,
      borderColor: state.isFocused ? `${COLOR_PRIMARY}` : `${COLOR_GRAY_300}`,
      boxShadow: state.isFocused
        ? `rgb(255, 255, 255) 0px 0px 0px 0px, rgba(68, 166, 89, 0.4) 0px 0px 0px 3px, rgba(0, 0, 0, 0) 0px 0px 0px 0px`
        : undefined,
      ":hover": {
        borderColor: `${COLOR_PRIMARY}`,
        boxShadow: `rgb(255, 255, 255) 0px 0px 0px 0px, rgba(68, 166, 89, 0.4) 0px 0px 0px 3px, rgba(0, 0, 0, 0) 0px 0px 0px 0px`,
      },
    };
  },
  indicatorSeparator: (provided: any) => {
    return {
      ...provided,
      backgroundColor: `${COLOR_GRAY_300}`,
    };
  },
  dropdownIndicator: (provided: any, state: any) => {
    return {
      ...provided,
      color: state.isFocused ? `${COLOR_PRIMARY}` : `${COLOR_GRAY_300}`,
      ":hover": {
        color: `${COLOR_PRIMARY}`,
      },
    };
  },
  menu: (provided: any) => {
    return {
      ...provided,
      borderColor: `${COLOR_GRAY_300}`,
    };
  },
  option: (provided: any, state: any) => {
    return {
      ...provided,
      color: COLOR_BLACK,
      backgroundColor: state.isSelected ? `${COLOR_GRAY_300}` : undefined,
      ":active": {
        backgroundColor: `${COLOR_GRAY_300}`,
      },
    };
  },
};

const Select = ({
  value,
  valueKey,
  options,
  ...props
}: Props & { valueKey?: string }) => {
  /**
   * Added `valueKey` to allow for only the `key` to be passed and it will find valid option in
   * `options`. Will look at `value` then `valueKey`.
   */

  let selectedValue:
    | {
        label: string;
        value: string;
      }
    | readonly {
        label: string;
        value: string;
      }[]
    | null
    | undefined;

  if (value) {
    selectedValue = value;
  } else if (valueKey && options) {
    const foundValue = options.find((option) => option.value === valueKey);
    selectedValue =
      (foundValue as
        | {
            label: string;
            value: string;
          }
        | readonly {
            label: string;
            value: string;
          }[]
        | undefined) || null;
  } else {
    selectedValue = null;
  }

  return (
    <ReactSelect
      styles={customStyles}
      value={selectedValue}
      options={options}
      {...props}
    />
  );
};

export default Select;
